import Vue from 'vue'
import Router from 'vue-router'
import PageNotFound from '@/views/PageNotFound'

Vue.use(Router)

const myRouter = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
          path: '/',
          redirect: '/iscrizioni/newsletter'
        },
        {
          path: '/iscrizioni/:pagePermalink',
          component: () => import(/* webpackChunkName: "MbSubscriptionPage" */ '@/views/subscriptions/MbSubscriptionPage.vue')
        },
        {
          path: '/iscrizioni/:pagePermalink/conferma',
          component: () => import(/* webpackChunkName: "MbSubscriptionConfirmEmail" */ '@/views/subscriptions/MbSubscriptionConfirmEmail')
        },
        {
          path: '/iscrizioni/:pagePermalink/conferma/:otp',
          component: () => import(/* webpackChunkName: "MbSubscriptionCompleted" */ '@/views/subscriptions/MbSubscriptionCompleted')
        },
        {
          path: '/iscrizioni/:pagePermalink/conferma/:otp',
          component: () => import(/* webpackChunkName: "MbSubscriptionCompleted" */ '@/views/subscriptions/MbSubscriptionCompleted')
        },
        {
          path: '/page-not-found',
          component: () => import(/* webpackChunkName: "PageNotFound" */ '@/views/PageNotFound')
        },
        {
          path: '/cookie-policy',
          component: () => import(/* webpackChunkName: "PageNotFound" */ '@/views/cookie/CookiePolicy')
        },
        { path: "*", component: PageNotFound }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return { x: 0, y: 0 }
        }
    }
});

myRouter.beforeEach( (to, from, next) => {
  return next();
});

export default myRouter;
